import { render } from "./JLAlert.vue?vue&type=template&id=e802cfb2&scoped=true"
import script from "./JLAlert.vue?vue&type=script&lang=js"
export * from "./JLAlert.vue?vue&type=script&lang=js"

import "./JLAlert.vue?vue&type=style&index=0&id=e802cfb2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\versatech_vex\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e802cfb2"]])

export default __exports__